<template>
  <div class="container-fluid text-center">
    <div class="content-wrap-x-small content-pad content-pad--big-top">
      <div class="check-wrap" />
      <h2 class="mt-3 mb-4">
        {{ $t('offer.thanks.headline') }}
      </h2>
      <template v-if="!underwriting">
        <p>{{ $t('offer.thanks.text_01') }}</p>
        <p>{{ $t('offer.thanks.text_02') }}</p>
        <p>{{ $t('offer.thanks.text_03') }}</p>
      </template>
      <p v-else>
        {{ $t('weWillTakeCare') }}
      </p>
      <dx-button :text="$t('toMainPage')" :external-link="websiteHome" />
    </div>
  </div>
</template>

<script>
import { DxButton } from '@sumcumo/dextra-frontend-component-lib-old'

export default {
  name: 'OfferThankYou',
  meta: {
    isPublic: true,
    trackingId: 'dextra.rechtsschutz-antragsstrecke.willkommen-bei-dextra',
    offerStep: 5,
  },
  components: {
    DxButton,
  },
  layout: 'website',
  // maybe use a dynamic layout here some day?
  // layout: ({ store }) => (store.getters.isLoggedIn ? 'default' : 'website'),
  data() {
    return {
      websiteHome: `${process.env.DEXTRA_WEBSITE_URL}${
        this.$i18n.locale === 'fr' ? '/fr' : ''
      }`,
    }
  },
  computed: {
    underwriting() {
      return this.$route.query.underwriting === 'true'
    },
  },
  mounted() {
    this.$store.commit('RESET_STORE_OFFER')
  },
  nuxtI18n: {
    paths: {
      de: '/rechtsschutz-antragsstrecke/willkommen-bei-dextra/',
      fr: '/protection-juridique-formulaire-de-demande/bienvenue-chez-dextra/',
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'index';
</style>
